export var VERSION = "1.6.0";